import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local');
}

// `lock` override bypasses navigator.locks coordination so a stuck lock in a
// closed tab / crashed extension can't leave getSession() hanging forever.
// Concurrent token refreshes across tabs will still be safe; they just won't
// serialize through the Web Locks API.
export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});

export default supabase;
